import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="site-shell">
      <Navbar />

      <main className="main-content">
        <div className="container">
          <Outlet />
        </div>
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
}